'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n    display: block;\n  '], ['\n    display: block;\n  ']),
    _templateObject2 = _taggedTemplateLiteral(['\n    grid-template-columns: 1fr;\n  '], ['\n    grid-template-columns: 1fr;\n  ']),
    _templateObject3 = _taggedTemplateLiteral(['\n    flex-direction: column;\n  '], ['\n    flex-direction: column;\n  ']),
    _templateObject4 = _taggedTemplateLiteral(['\n    &:first-child {\n      margin-bottom: -1px;\n      margin-right: 0;\n      border-radius: 3px 3px 0 0;\n    }\n    &:last-child {\n      margin-top: -1px;\n      margin-left: 0;\n      border-radius: 0 0 3px 3px;\n    }\n  '], ['\n    &:first-child {\n      margin-bottom: -1px;\n      margin-right: 0;\n      border-radius: 3px 3px 0 0;\n    }\n    &:last-child {\n      margin-top: -1px;\n      margin-left: 0;\n      border-radius: 0 0 3px 3px;\n    }\n  ']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _UICardGrid = require('UIComponents/card/UICardGrid');

var _UICardGrid2 = _interopRequireDefault(_UICardGrid);

var _HubMap = require('self-service-api/constants/HubMap');

var _HubMap2 = _interopRequireDefault(_HubMap);

var _FormattedMessage = require('I18n/components/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _HighlightedMerchCard = require('./HighlightedMerchCard');

var _HighlightedMerchCard2 = _interopRequireDefault(_HighlightedMerchCard);

var _HighlightedMerchHeaderConfig = require('pricing-pages-unified-ui/constants/HighlightedMerchHeaderConfig');

var _HighlightedMerchHeaderConfig2 = _interopRequireDefault(_HighlightedMerchHeaderConfig);

var _partial = require('transmute/partial');

var _partial2 = _interopRequireDefault(_partial);

var _responsiveBreakpoints = require('../../utils/responsiveBreakpoints');

var _responsiveBreakpoints2 = _interopRequireDefault(_responsiveBreakpoints);

var _wtDebounce = require('../../utils/wtDebounce');

var _wtDebounce2 = _interopRequireDefault(_wtDebounce);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var CardGrid = (0, _styledComponents2.default)(_UICardGrid2.default).withConfig({
  displayName: 'HubTierInfo__CardGrid'
})(['grid-column-gap:24px;', ' ', ';'], _responsiveBreakpoints2.default.tabletPortrait(_templateObject), _responsiveBreakpoints2.default.phone(_templateObject2));

var SelectorButtonWrapper = _styledComponents2.default.div.withConfig({
  displayName: 'HubTierInfo__SelectorButtonWrapper'
})(['display:flex;width:80%;margin:0 auto;', ''], _responsiveBreakpoints2.default.phoneLarge(_templateObject3));

var SelectorButton = _styledComponents2.default.button.withConfig({
  displayName: 'HubTierInfo__SelectorButton'
})(['font-size:0.75rem;padding:calc(1rem + 1px) 2rem;background:#fff;flex-grow:1;flex-basis:33%;border:1px solid #7fd1de;transition:background-color 0.3s;&:first-child{margin-right:-1px;border-radius:3px 0 0 3px;}&:last-child{margin-left:-1px;border-radius:0 3px 3px 0;}&:hover{background-color:#e5f5f8;}&.active{font-weight:500;padding:1rem 2rem;border-width:2px;border-color:#00a4bd;background-color:#e5f5f8;}', ''], _responsiveBreakpoints2.default.phoneLarge(_templateObject4));

var HubTierInfo = function (_React$Component) {
  _inherits(HubTierInfo, _React$Component);

  function HubTierInfo(props) {
    _classCallCheck(this, HubTierInfo);

    var _this = _possibleConstructorReturn(this, (HubTierInfo.__proto__ || Object.getPrototypeOf(HubTierInfo)).call(this, props));

    _this.handleWindowSizeChange = function () {
      _this.setState({
        width: window.innerWidth
      });
    };

    _this.handleKeyChange = function (selectedId) {
      return _this.setState({
        selectedId: selectedId,
        activeCard: selectedId
      });
    };

    _this.state = {
      width: window.innerWidth,
      selectedId: 0,
      activeCard: 0
    };
    return _this;
  }

  _createClass(HubTierInfo, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this2 = this;

      var resizeWindow = (0, _wtDebounce2.default)(function () {
        _this2.handleWindowSizeChange();
      }, 250);
      window.addEventListener('resize', resizeWindow);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setState({
        selectedId: _HubMap2.default[this.props.hub].highlightedPaidMerch[0],
        activeCard: _HubMap2.default[this.props.hub].highlightedPaidMerch[0]
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleWindowSizeChange);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var hub = this.props.hub;

      var highlightedMerch = _HubMap2.default[hub].highlightedPaidMerch;
      var isMobile = this.state.width <= 800;

      if (isMobile) {
        return _react2.default.createElement(
          _react2.default.Fragment,
          null,
          _react2.default.createElement(
            SelectorButtonWrapper,
            null,
            highlightedMerch.map(function (merchId) {
              return _react2.default.createElement(
                SelectorButton,
                {
                  key: merchId,
                  onClick: (0, _partial2.default)(_this3.handleKeyChange, merchId),
                  className: _this3.state.activeCard === merchId ? 'active' : ''
                },
                _react2.default.createElement(_FormattedMessage2.default, {
                  message: _HighlightedMerchHeaderConfig2.default[merchId].title
                })
              );
            })
          ),
          this.state.selectedId > 0 && _react2.default.createElement(_HighlightedMerchCard2.default, {
            hub: hub,
            merchandiseId: this.state.selectedId
          })
        );
      }

      return _react2.default.createElement(
        CardGrid,
        { className: 'hub-tier-info', columns: 3 },
        highlightedMerch.map(function (merchId) {
          return _react2.default.createElement(_HighlightedMerchCard2.default, {
            key: merchId,
            hub: hub,
            merchandiseId: merchId
          });
        })
      );
    }
  }]);

  return HubTierInfo;
}(_react2.default.Component);

HubTierInfo.propTypes = {
  hub: _react.PropTypes.string.isRequired
};

exports.default = HubTierInfo;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/product-pages/HubTierInfo.js
// module id = 340
// module chunks = 3 4